<div class="toolbar-wrapper">
  <ns-application-bar [selectedItemKey]="applicationBarModuleKey" [apiPath]="projectNavigationAPI" [baseURL]="studioURL"></ns-application-bar>
</div>
<router-outlet></router-outlet>

